
  import { Component, Vue, Watch } from "vue-property-decorator";
    export default {
        name: "tip-messages"
    }
